import { useQuery } from "@tanstack/react-query";
import { AnalyticsService } from "@/services/analytics.service";
import { useAuthStore } from "@/stores/auth-store";
import { adsHttpClient } from "@/utils/ads.http";

const analyticsService = new AnalyticsService(adsHttpClient);

async function fetchBrandPerformanceDashboardEmbedInfo() {
  return analyticsService.getBrandPerformanceEmbedInfo();
}

export function useBrandPerformanceDashboardEmbedInfo() {
  const realm = useAuthStore((state) => state.realm);
  const email = useAuthStore((state) => state.user?.email);

  return useQuery({
    queryKey: ["brand-performance-dashboard-embed-info", realm, email],
    queryFn: fetchBrandPerformanceDashboardEmbedInfo,
    enabled: Boolean(realm && email),
    refetchOnMount: true,
    staleTime: 1000 * 60 * 500,
    refetchInterval: 1000 * 60 * 500,
  });
}
